module.exports = ".admin-login-panel{position:fixed;bottom:0;right:0;display:flex;flex-direction:column;width:350px;height:55px;font-size:14px;background:#fdfba8;color:#58585b;border:1px solid #ab1005;align-items:center;justify-content:center;cursor:pointer}.admin-login-panel p{margin:0;text-align:center}.admin-login-panel p+p{font-size:20px}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/admin-login-panel.component.scss
// module id = 522
// module chunks = 0